/* eslint-disable linebreak-style */
import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Skeleton from 'react-loading-skeleton'

const SkeletonTable = props => (
  <Fragment>
    {Array(10)
      .fill()
      .map((item, index) => (
        <tr key={index}>
          { Array(props.numberOfColumns)
            .fill()
            .map((items, i) => (
              <td key={i}>
                <Skeleton width="80%" />
              </td>
            ))}
          {/* <td>
                    <Skeleton width="80%" />
                  </td>
                  <td>
                    <Skeleton width="80%" />
                  </td>
                  <td>
                    <Skeleton width="80%" />
                  </td>
                  <td>
                    <Skeleton width="80%" />
                  </td>
                  <td>
                    <Skeleton width="80%" />
                  </td>
                  <td>
                    <Skeleton width="80%" />
                  </td>
                  <td>
                    <Skeleton width="80%" />
                  </td> */}

        </tr>
      ))}
  </Fragment>
)

SkeletonTable.propTypes = {
  numberOfColumns: PropTypes.number.isRequired
}

export default SkeletonTable
